<app-dashboard-element icon="instruction" title="dashboard.last_content.title"
    [description]="clientHaveContent() ? 'dashboard.last_content.description' : undefined">

    @if(!clientHaveContent()){
    <app-empty-content-list-element />
    }

    @for(content of contents();track $index){
    <app-content-list-light-element [content]="content" />
    }
</app-dashboard-element>